import Nav from "@/components/layout/Nav";
import Footer from "@/components/layout/Footer";
import AskBHTAI from "@/components/ai/AskBHTAI";
import CustomCursor from "@/components/common/CustomCursor";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function Layout({ children }) {
  const location = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [location.pathname]);

  return (
    <div className="relative min-h-screen bg-bht-void text-white">
      <CustomCursor />
      <a
        href="#main"
        className="sr-only focus:not-sr-only focus:fixed focus:left-4 focus:top-4 focus:z-[200] focus:rounded focus:bg-bht-gold focus:px-4 focus:py-2 focus:text-bht-void"
      >
        Skip to content
      </a>
      <Nav />
      <main id="main" className="pt-[76px]">
        {children}
      </main>
      <Footer />
      <AskBHTAI />
    </div>
  );
}
